import XyImageEditor from './xy-image-editor.vue'
// const imageEditor = {
//     install: function (Vue) {
//         Vue.component(xyImageEditor.name, xyImageEditor)
//     }
// }
XyImageEditor.install = function (Vue) {
    Vue.component(XyImageEditor.name, XyImageEditor)
}
if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.component(XyImageEditor.name, XyImageEditor)
}
export default XyImageEditor


// WEBPACK FOOTER //
// ./src/lib/index.js